import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from 'components/inputs/Button/Button'

interface UploadFilesButtonProps {
  className?: string
  onFilesChange?: (file: File[]) => void
  children?: ReactNode
  multiple?: boolean
  accept?: string
  disabled?: boolean
}

const UploadFilesButton = ({
  onFilesChange,
  className,
  children,
  multiple = false,
  accept = '',
  disabled = false,
}: UploadFilesButtonProps): JSX.Element => {
  const { t } = useTranslation()

  const handleFilesChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const files = e.target.files ? Array.from(e.target.files) : []
    onFilesChange?.(files)
  }

  return (
    <>
      <input
        id='raised-button-file'
        accept={accept}
        style={{ display: 'none' }}
        type='file'
        onChange={handleFilesChange}
        multiple={multiple}
        disabled={disabled}
      />
      <label htmlFor='raised-button-file'>
        <Button component='span' className={className}>
          {children || multiple ? t('common.chooseFiles') : t('common.chooseFile')}
        </Button>
      </label>
    </>
  )
}

export { UploadFilesButton }
